module.exports = __webpack_public_path__ + "img/故宫.e1c4cbc8.png";